import React, { useEffect, useState } from "react";
import "../../Styles/yellowcalf.css/Accountant.css";
import { FaBell, FaGraduationCap, FaArrowRight } from "react-icons/fa";
import {
  simpleGetCallWithErrorResponse,
  simplePostCall,
} from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";

function Accountant() {
  const [selectedStudent, setSelectedStudent] = useState("");
  const [AccountantData, setAccountantData] = useState({});
  const [AccountantDataCount, setAccountantDataCount] = useState({});
  console.log("AccountantData", AccountantData);

  const [AccountantStudentList, setAccountantStudentList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [selectedStudentId, setSelectedStudentId] = useState(""); 
    const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");

  const handleClear = () => {
    setSelectedStudent("");
  };
  useEffect(() => {
    loadDataSocket();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadDataSocket = async () => {
    setIsLoading(true); // Start loading

    // 1. Get credentials from localStorage (instead of hardcoding)
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id) || 1005, // Fallback to 1005 if not found
      api_key: api_key || "b9359f494e77b6589ce12dd62518c585",
    };

    try {
      // 2. Fix: Pass URL and Body as separate arguments
      // Use the variable from ApiConfig directly
      const response = await simplePostCall(
        ApiConfig.dashboradlist,
        JSON.stringify(requestBody),
      );

      console.log("Response Received:", response);

      // 3. Logic Fix: Only set data if it exists

      if (response?.result) {
        setAccountantDataCount(response); // Set the actual data
        const list = response.studentList || [];
        setAccountantStudentList(list);
        // Auto-load first student by default
        if (list.length > 0) {
          const firstId = list[0].student_id;
          setSelectedStudentId(firstId);
          await loadDataStudent(firstId);
        }
      } else {
        // setAccountantData([]); // Clear data if empty or error
      }
    } catch (error) {
      console.error("Error loading orders:", error);
      // setAccountantData([]); // Ensure state is consistent on error
    } finally {
      setIsLoading(false); // Stop loading regardless of outcome
    }
  };

  const handleSelect = (e) => {
    const studentId = e.target.value;
    setSelectedStudentId(studentId);
    if (studentId) {
      loadDataStudent(studentId);
    }
  };

  const loadDataStudent = async (id) => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      student_id: id, // Use the ID passed from the select
    };

    try {
      const response = await simplePostCall(
        ApiConfig.dashboradStudentList,
        JSON.stringify(requestBody),
      );

      // Based on your response example, it returns an object with { result: true, student_data: [...] }
      if (response?.result) {
        setAccountantData(response);
      } else {
        setAccountantData(null);
      }
    } catch (error) {
      console.error("Error loading student:", error);
      setAccountantData(null);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="acc-main-content" style={{ paddingTop: "20px" }}>
      {isLoading ? (
        <div
          style={{
            minHeight: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <ScaleLoader
            color="#F4BB44"
            style={{ textAlign: "center", padding: "10px" }}
          />
          <p style={{ marginTop: "12px", color: "#555" }}>
            Loading dashboard, please wait...
          </p>
        </div>
      ) : (
        <div className="acc-container">
          {/* Top Row Cards */}
          <div className="acc-row">
            <div className="acc-col-12">
              <div className="acc-panel-white acc-mb">
                <div className="acc-panel-body">
                  <div className="acc-row">
                    <div className="acc-col-3">
                      <div
                        className="acc-card acc-card-fee"
                        style={{ marginTop: "20px" }}
                      >
                        <div className="acc-card-body">
                          <h5
                            className="acc-card-title"
                            style={{ marginTop: "25px" }}
                          >
                            Todays Fee Collection
                          </h5>
                          <h3 className="acc-card-text" style={{ marginTop: "25px" }}>
                            <span className="acc-text-big">{customer_currency}</span>
                            {AccountantDataCount.gettodayFee || 0}
                          </h3>
                        </div>
                      </div>
                    </div>

                    <div className="acc-col-3">
                      <div
                        className="acc-card acc-card-busfare"
                        style={{ marginTop: "20px" }}
                      >
                        <div className="acc-card-body">
                          <h5
                            className="acc-card-title"
                            style={{ marginTop: "25px" }}
                          >
                            Todays Busfare Collections
                          </h5>    
                          <h3 className="acc-card-text" style={{ marginTop: "25px" }}>
                            <span className="acc-text-big">{customer_currency}</span>
                            {AccountantDataCount.getbusfaredata || 0}
                          </h3>
                        </div>
                      </div>
                    </div>

                    <div className="acc-col-3">
                      <div
                        className="acc-card acc-card-wallet"
                        style={{ marginTop: "20px" }}
                      >
                        <div className="acc-card-body">
                          <h5
                            className="acc-card-title"
                            style={{ marginTop: "25px" }}
                          >
                            Todays Wallet Recharge
                          </h5>
                          <h3 className="acc-card-text" style={{ marginTop: "25px" }}>
                            <span className="acc-text-big">{customer_currency}</span>
                            {AccountantDataCount.getWallettoday || 0}
                          </h3>
                        </div>
                      </div>
                    </div>

                    <div className="acc-col-3">
                      <div
                        className="acc-card acc-card-collection"
                        style={{ marginTop: "20px" }}
                      >
                        <div className="acc-card-body">
                          <h5
                            className="acc-card-title"
                            style={{ marginTop: "25px" }}
                          >
                            Todays Final Due & Registration Collection
                          </h5>
                          <h3 className="acc-card-text" style={{ marginTop: "25px" }}>
                            <span className="acc-text-big">{customer_currency}</span>
                            {AccountantDataCount.calculateTotalDuesAndReg || 0}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Middle Row Panels */}
         <div className="acc-row">
  <div className="acc-col-12">
    <div className="acc-panel-white">
      <div className="acc-panel-body">
        <div className="acc-row">
          <div className="acc-col-4">
            <div
              className="acc-panel acc-panel-payment acc-height-box"
              style={{ marginTop: "20px" }}
            >
              <div className="acc-panel-body acc-padding-25 acc-text-center">
                <div className="acc-space10">
                  <h5
                    className="acc-text-white acc-semi-bold acc-no-margin acc-pb-5"
                    style={{ marginTop: "25px" }}
                  >
                    <strong style={{ fontWeight: "inherit" }}>
                      {" "}
                      Pending Payments
                    </strong>
                  </h5>
                  <h3 className="acc-text-white acc-no-margin acc-label-txt">
                    <span className="acc-text-big">{customer_currency}</span>
                    {AccountantDataCount.invoiceFeeSumpendingdues}
                  </h3>
                  {/* <h6 className="subinfo-text-white">28 Invoices</h6> */}
                </div>
                <span className="acc-text-light">
                  <a
                    href="/PendingInvoices"
                    className="acc-link-white"
                  >
                    <FaArrowRight style={{ marginRight: "5px" }} />
                    View
                  </a>
                </span>
              </div>
            </div>
          </div>

          <div className="acc-col-4">
            <div
              className="acc-panel acc-panel-feedues acc-height-box"
              style={{ marginTop: "20px" }}
            >
              <div className="acc-panel-body acc-padding-20 acc-text-center">
                <div className="acc-space10">
                  <h5
                    className="acc-text-white acc-semi-bold acc-no-margin acc-pb-5"
                    style={{ marginTop: "10px" }}
                  >
                    <strong style={{ fontWeight: "inherit" }}>
                      Pending Fee Dues
                    </strong>
                  </h5>
                  <h3 className="acc-text-white acc-no-margin acc-label-txt">
                    <span className="acc-text-big">{customer_currency}</span>
                    {AccountantDataCount.invoiceSumpending}
                  </h3>
                  {/* <h6 className="subinfo-text-white">5144263</h6> */}
                </div>
                <span className="acc-text-light">
                  <a
                    href="/PendingInvoices"
                    className="acc-link-white"
                  >
                    <FaArrowRight style={{ marginRight: "5px" }} />
                    View
                  </a>
                </span>
              </div>
            </div>
          </div>

          <div className="acc-col-4">
            <div
              className="acc-panel acc-panel-upecomingfee acc-height-box"
              style={{ marginTop: "20px" }}
            >
              <div className="acc-panel-body acc-padding-20 acc-text-center">
                <div className="acc-space10">
                  <h5
                    className="acc-text-white acc-semi-bold acc-no-margin acc-pb-5"
                    style={{ marginTop: "10px" }}
                  >
                    <strong style={{ fontWeight: "inherit" }}>
                      Upcoming Fee
                    </strong>
                  </h5>
                  <h3 className="acc-text-white acc-no-margin acc-label-txt">
                    <span className="acc-text-big">{customer_currency}</span>
                    {AccountantDataCount.upcoming_fee_sum}
                  </h3>
                  <h6 className="subinfo-text-white">Fee Dues</h6>
                </div>
                <span className="acc-text-light">
                  <a
                    href="/UpcomingInvoices"
                    className="acc-link-white"
                  >
                    <FaArrowRight style={{ marginRight: "5px" }} />
                    View
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

          {/* Overall Project Summary */}
          <div className="acc-row">
            <div className="acc-col-12">
              <div className="acc-panel-white acc-mb">
                <div className="acc-panel-body">
                  <h5 style={{ fontWeight: 700, margin: "10px 0 15px 5px", color: "#444" }}>
                    Overall Project Summary
                  </h5>
                  <div className="acc-row">
                    <div className="acc-col-3">
                      <div className="acc-card acc-card-fee" style={{ marginTop: "10px" }}>
                        <div className="acc-card-body">
                          <h5 className="acc-card-title" style={{ marginTop: "15px" }}>
                            Total Today's Collection
                          </h5>
                          <h3 className="acc-card-text" style={{ marginTop: "15px" }}>
                            <span className="acc-text-big">{customer_currency}</span>
                            {(
                              parseFloat(AccountantDataCount.gettodayFee || 0) +
                              parseFloat(AccountantDataCount.getbusfaredata || 0) +
                              parseFloat(AccountantDataCount.getWallettoday || 0) +
                              parseFloat(AccountantDataCount.calculateTotalDuesAndReg || 0)
                            ).toFixed(2)}
                          </h3>
                        </div>
                      </div>
                    </div>

                    <div className="acc-col-3">
                      <div className="acc-card acc-card-collection" style={{ marginTop: "10px" }}>
                        <div className="acc-card-body">
                          <h5 className="acc-card-title" style={{ marginTop: "15px" }}>
                            Total Pending Dues
                          </h5>
                          <h3 className="acc-card-text" style={{ marginTop: "15px" }}>
                            <span className="acc-text-big">{customer_currency}</span>
                            {(
                              parseFloat(AccountantDataCount.invoiceFeeSumpendingdues || 0) +
                              parseFloat(AccountantDataCount.invoiceSumpending || 0)
                            ).toFixed(2)}
                          </h3>
                        </div>
                      </div>
                    </div>

                    <div className="acc-col-3">
                      <div className="acc-card acc-card-busfare" style={{ marginTop: "10px" }}>
                        <div className="acc-card-body">
                          <h5 className="acc-card-title" style={{ marginTop: "15px" }}>
                            Upcoming Fee
                          </h5>
                          <h3 className="acc-card-text" style={{ marginTop: "15px" }}>
                            <span className="acc-text-big">{customer_currency}</span>
                            {parseFloat(AccountantDataCount.upcoming_fee_sum || 0).toFixed(2)}
                          </h3>
                        </div>
                      </div>
                    </div>

                    <div className="acc-col-3">
                      <div className="acc-card acc-card-wallet" style={{ marginTop: "10px" }}>
                        <div className="acc-card-body">
                          <h5 className="acc-card-title" style={{ marginTop: "15px" }}>
                            Net Balance
                          </h5>
                          <h3 className="acc-card-text" style={{ marginTop: "15px" }}>
                            <span className="acc-text-big">{customer_currency}</span>
                            {(
                              parseFloat(AccountantDataCount.gettodayFee || 0) +
                              parseFloat(AccountantDataCount.getbusfaredata || 0) +
                              parseFloat(AccountantDataCount.getWallettoday || 0) +
                              parseFloat(AccountantDataCount.calculateTotalDuesAndReg || 0) -
                              parseFloat(AccountantDataCount.invoiceFeeSumpendingdues || 0) -
                              parseFloat(AccountantDataCount.invoiceSumpending || 0)
                            ).toFixed(2)}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Student Dropdown */}
          <div className="acc-vacation-index acc-align-buttons">
            <div className="acc-row">
              <div className="acc-col-12">
                <div className="acc-reportkey" align="center">
                  <div className="acc-panel-white">
                    <div className="acc-panel-body">
                      <div
                        className="acc-row"
                        style={{ marginTop: "5px", marginBottom: "10px" }}
                      >
                        <div className="acc-col-11" style={{ flex: 1 }}>
                          <select
                            id="acc-student-select"
                            className="acc-form-control acc-search-select"
                            name="student"
                            value={selectedStudentId}
                            onChange={handleSelect}
                          >
                            <option value="">Select Student</option>
                            {AccountantStudentList.map((std) => (
                              <option
                                key={std.student_id}
                                value={std.student_id}
                              >
                                {std.student_name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="acc-col-1">
                          <button
                            style={{
                              backgroundColor: "#5f8295",
                              height: "38px",
                              marginTop: "-1px",
                            }}
                            className="acc-btn acc-btn-blue"
                            onClick={() => setAccountantData(null)}
                          >
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4">
            {isLoading ? (
              /* Show this when API is fetching */
              <div className="loader-container">
                <div className="spinner"></div>
                <p className="loading-text">Fetching data, please wait...</p>
              </div>
            ) : (
              /* Show data when loading is finished */
              <>{AccountantData && <StudentDetail data={AccountantData} currency={customer_currency} />}</>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const StudentDetail = ({ data, currency }) => {
  // Safe extraction with optional chaining
  const student = data?.student_data?.[0] || {};
  const attendance = data?.student_attendance?.[0] || {};
  const wallet = data?.wallet?.[0] || { wallet_amount: 0 };
  const fees = data?.student_fee || [];
  const recharges = data?.wallet_recharge || [];

  const baseUrl = "https://stage.edsys.in/";
const profileImage = 
  student.student_profilepicture && 
  student.student_profilepicture !== "null" && 
  student.student_profilepicture !== ""
    ? `${baseUrl}${student.student_profilepicture}`
    : "https://stage.edsys.in/uploads/general/student_avatar.png";

  return (
    <div className="container-fluid p-4" style={{ backgroundColor: "#f8f8f8" }}>
      <div className="row bg-white shadow-sm rounded p-3 mb-4">
        <div className="col-md-2 text-center border-end">
          <div
            style={{
              fontSize: "16px",
              fontWeight: "600",
              marginBottom: "10px",
              color: "#555",
              backgroundColor: "#ddd",
              padding: "5px 0",
              borderRadius: "4px",
            }}
          >
            {student.student_name || "N/A"}
          </div>
  <div
    style={{
      width: "120px",
      height: "120px",
      margin: "0 auto",
      borderRadius: "8px",
      overflow: "hidden",
      border: "1px solid #ddd",
    }}
  >
 <img
  src={profileImage}
  alt="Profile"
  style={{ width: "100%", height: "100%", objectFit: "cover" }}
  onError={(e) => {
    e.target.src = "https://stage.edsys.in/uploads/general/student_avatar.png";
  }}
/>
  </div>
        </div>

        <div className="col-md-5">
          <h6 className="fw-bold mb-2">Student Details</h6>
          <table className="table table-striped table-bordered table-sm mb-0">
            <tbody>
              <tr>
                <td className="fw-semibold">Name</td>
                <td>{student.student_name}</td>
              </tr>
              <tr>
                <td>Class</td>
                <td>{attendance.student_class || "N/A"}</td>
              </tr>
              <tr>
                <td>Address</td>
                <td>{attendance.student_address || "N/A"}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="col-md-5">
          <h6 className="fw-bold mb-2">Wallet Summary</h6>
          <div className="p-3 border rounded bg-light">
            <h4 className="text-success">Balance: {currency}{wallet.wallet_amount}</h4>
          </div>
        </div>
      </div>
      {/* Corrected Fee Table */}
      <h5 className="mt-4 mb-3">Fee Due Details</h5>{" "}
      {/* Use h5 if SectionHeader isn't defined */}
      <table className="table table-striped table-bordered text-center">
        <thead className="table-light" style={{textAlign:'center'}}>
          <tr>
            <th >Sr No</th>
            <th>Invoice No</th>
            <th>Amount</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {fees.length > 0 ? (
            fees.map((fee, index) => (
              <tr key={fee.fee_invoice_id}>
                {" "}
                {/* ✅ Fixed: Added 'tr' tag here */}
                <td>{index + 1}</td>
                <td>{fee.fee_invoice_id}</td>
                <td>{currency}{fee.fee_invoice_amount}</td>
                <td>
                  <span className="badge bg-warning text-dark">
                    {fee.fee_invoice_status}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-muted">
                No results found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <h5 className="mt-4 mb-3">Last 5 Wallet Recharge</h5>
      <table className="table table-striped table-bordered align-middle">
        <thead className="table-light">
          <tr>
            <th>Sr No</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Reference</th>
          </tr>
        </thead>
        <tbody>
          {recharges.length > 0 ? (
            recharges.slice(0, 5).map((item, index) => (
              <tr key={item.wallet_recharge_id}>
                <td>{index + 1}</td>
                <td>{currency}{item.wallet_recharge_amount}</td>
                <td>{item.wallet_recharge_date || "N/A"}</td>
                <td>{item.wallet_recharge_reference_no || "N/A"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-muted">
                No records
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const SectionHeader = ({ title }) => (
  <div className="d-flex align-items-center my-3">
    <FaBell className="text-dark me-2" />
    <h6 className="fw-bold mb-0">{title}</h6>
  </div>
);

export default Accountant;
